class ConfigService {
  constructor() {
    this.config = null;
    this.defaultConfig = {
      serviceName: "Cart Scheduler",
      maxBookingDays: 14,
      weekdayStartHour: 8,
      weekdayEndHour: 18,
      weekendStartHour: 10,
      weekendEndHour: 16,
      thursdaySpecialRules: true,
      maxBookingDuration: 2,
      availableCarts: [
        { id: "1", name: "Vagn 1 & 2" },
        { id: "2", name: "Vagn 3 & 4" }
      ],
      infoMessages: {
        enabled: true,
        messages: [
          {
            id: "thursday",
            weekdays: [4], // Thursday
            enabled: true,
            message: "På torsdagar är det vagndag i Vasaparken, vilket innebär att vi har tillstånd för två vagnar mellan 8-18. Vagn 3&4 är reserverade för möte för tjänst 11:30. Vid frågor kontakta Rickard eller Meliza."
          },
          {
            id: "weekend",
            weekdays: [0, 6], // Sunday, Saturday
            enabled: true,
            message: "Vi har tillstånd för två vagnar i Vasaparken mellan 10-16. Övrig tid och plats flyttar vi vagnarna efter en kort stund. Vid frågor kontakta Rickard eller Meliza."
          },
          {
            id: "weekday",
            weekdays: [1, 2, 3, 5], // Monday, Tuesday, Wednesday, Friday
            enabled: true,
            message: "Vi har tillstånd för två vagnar i Vasaparken mellan 8-18. Övrig tid och plats flyttar vi vagnarna efter en kort stund. Vid frågor kontakta Rickard eller Meliza."
          }
        ]
      },
      emailSettings: {
        enabled: true,
        serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
        templateId: process.env.REACT_APP_EMAILJS_CONFIRM_TEMPLATE_ID,
        publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      },
      database: {
        type: "firebase", // Could be "firebase", "mongodb", "postgresql", etc.
        collections: {
          bookings: "booking",
          maintenanceBlocks: "maintenance_blocks",
          appConfig: "app_config"
        }
      },
      homePageInfo: {
        enabled: false,
        title: "Just nu",
        message: ""
      }
    };
  }

  async loadConfig() {
    try {
      // Try to load from environment variables first
      const envConfig = this.loadFromEnvironment();
      
      // Then try to load from database
      const dbConfig = await this.loadFromDatabase();
      
      // Merge configurations (env overrides db overrides default)
      this.config = {
        ...this.defaultConfig,
        ...dbConfig,
        ...envConfig
      };
      
      return this.config;
    } catch (error) {
      console.error("Error loading config:", error);
      this.config = this.defaultConfig;
      return this.config;
    }
  }

  loadFromEnvironment() {
    const envConfig = {};
    
    if (process.env.REACT_APP_SERVICE_NAME) {
      envConfig.serviceName = process.env.REACT_APP_SERVICE_NAME;
    }
    
    if (process.env.REACT_APP_MAX_BOOKING_DAYS) {
      envConfig.maxBookingDays = parseInt(process.env.REACT_APP_MAX_BOOKING_DAYS);
    }
    
    if (process.env.REACT_APP_WEEKDAY_START_HOUR) {
      envConfig.weekdayStartHour = parseInt(process.env.REACT_APP_WEEKDAY_START_HOUR);
    }
    
    if (process.env.REACT_APP_WEEKDAY_END_HOUR) {
      envConfig.weekdayEndHour = parseInt(process.env.REACT_APP_WEEKDAY_END_HOUR);
    }

    // Email settings from environment
    if (process.env.REACT_APP_EMAILJS_SERVICE_ID) {
      envConfig.emailSettings = {
        ...envConfig.emailSettings,
        enabled: true,
        serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
        templateId: process.env.REACT_APP_EMAILJS_CONFIRM_TEMPLATE_ID,
        publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      };
    }
    
    return envConfig;
  }

  async loadFromDatabase() {
    try {
      const { db } = await import("../firebase");
      const { collection, getDocs, query, where } = await import("firebase/firestore");
      
      const configQuery = query(
        collection(db, "app_config"),
        where("configType", "==", "main")
      );
      const querySnapshot = await getDocs(configQuery);
      
      if (!querySnapshot.empty) {
        const configDoc = querySnapshot.docs[0];
        return configDoc.data().config;
      }
      
      return {};
    } catch (error) {
      console.error("Error loading config from database:", error);
      return {};
    }
  }

  getConfig() {
    return this.config || this.defaultConfig;
  }

  getInfoMessageForWeekday(weekday) {
    const config = this.getConfig();
    
    if (!config.infoMessages.enabled) {
      return null;
    }
    
    const message = config.infoMessages.messages.find(msg => 
      msg.enabled && msg.weekdays.includes(weekday)
    );
    
    return message ? message.message : null;
  }

  isThursdaySpecial() {
    const config = this.getConfig();
    return config.thursdaySpecialRules;
  }

  getAvailableCarts() {
    const config = this.getConfig();
    return config.availableCarts;
  }

  getTimeSettings() {
    const config = this.getConfig();
    return {
      weekdayStartHour: config.weekdayStartHour,
      weekdayEndHour: config.weekdayEndHour,
      weekendStartHour: config.weekendStartHour,
      weekendEndHour: config.weekendEndHour,
      maxBookingDuration: config.maxBookingDuration
    };
  }
}

export default new ConfigService();